/** @type {Map<string, Promise<unknown>>} */
const inflight = new Map();

/**
 * Coalesce concurrent calls with the same key into one in-flight promise.
 * Used to avoid duplicate HTTP requests from React StrictMode double-mounting effects.
 */
export function dedupeRequest(key, requestFn) {
  const existing = inflight.get(key);
  if (existing) {
    return existing;
  }

  const promise = Promise.resolve()
    .then(requestFn)
    .finally(() => {
      if (inflight.get(key) === promise) {
        inflight.delete(key);
      }
    });

  inflight.set(key, promise);
  return promise;
}
